import { BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'
import { useEffect, useRef, useState } from 'react'

export const useMetrics = ({ startDate, endDate }) => {
  const abortRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!startDate || !endDate) return

    abortRef.current?.abort()

    const controller = new AbortController()
    abortRef.current = controller

    const fetchMetrics = async () => {
      setLoading(true)
      setError(null)

      try {
        const query =
          `?start_date=${startDate.format('YYYY-MM-DD HH:mm:ss')}` +
          `&end_date=${endDate.format('YYYY-MM-DD HH:mm:ss')}`

        const response = await fetchWithAuth(
          `${BASE_BACKEND_URL}/poc/fill_rates${query}`,
          { signal: controller.signal }
        )

        const json = await response
        setData(json)
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('Error loading metrics', e)
          setError(e)
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }

    fetchMetrics()

    return () => controller.abort()
  }, [startDate, endDate])

  return { loading, data, error }
}
